// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyCBf-NLFe7fNyHWehtekDZw4cYJaNdYLbU",
  authDomain: "contact-management-13308.firebaseapp.com",
  projectId: "contact-management-13308",
  storageBucket: "contact-management-13308.firebasestorage.app",
  messagingSenderId: "225641813397",
  appId: "1:225641813397:web:fc8395f8d03fa3e39e129c",
  measurementId: "G-8SXP937Y0C"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
